import { render, staticRenderFns } from "./AgendaConfiguracao.vue?vue&type=template&id=dcff13a6"
import script from "./AgendaConfiguracao.vue?vue&type=script&lang=ts"
export * from "./AgendaConfiguracao.vue?vue&type=script&lang=ts"
import style0 from "./AgendaConfiguracao.vue?vue&type=style&index=0&id=dcff13a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports